import React from 'react';

export default function Footer(){

    return(
        <footer>
            <p>Made with <i className='ri-chat-heart-fill'></i> by Nitish Bhardwaj | All right reserved 2021</p>
        </footer>
    )
}